export const isContactWorkflow = (workflow) =>
  workflow?.recipientKind === "contact";

export const isUserWorkflow = (workflow) => workflow?.recipientKind === "user";

export const supportsSelection = (workflow, mode) =>
  workflow?.selectionModes?.includes(mode) === true;
